<template>
  <AuthLayout :mode="mode">
    <Section
      :heading="
        contact?.first_name
          ? contact?.first_name + ' ' + contact?.last_name
          : ''
      "
      :mode="mode"
    />
    <AppCard
      :mode="mode"
      title="Contact Details"
      :isSmallTitle="true"
      :isCenter="false"
    >
      <template #body>
        <RecordDetails :mode="mode" :data="contactDetails" />
      </template>
    </AppCard>
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import { useUserStore } from "@S/user";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import { useGlobalErrorHandler } from "@L/errorHandler";
import ApiRequest from "@L/ApiRequest";
import AppCard from "@C/Common/AppCard.vue";
import RecordDetails from "@C/Common/RecordDetails.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "ContactDetails",
  components: {
    AuthLayout,
    Section,
    AppCard,
    RecordDetails,
  },
  setup() {
    const userStore = useUserStore();
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      userStore,
      toastStore,
      loaderStore,
      handleError,
    };
  },
  props: {
    mode: String,
  },
  data() {
    return {
      id: "",
      contactData: null,
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getContact();
  },
  methods: {
    async getContact() {
      this.loaderStore.setIsLoading(true);
      try {
        const { data } = await ApiRequest().get(`/contact/${this.id}`);
        if (data && data.contact) {
          this.contactData = data;
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
  },
  computed: {
    contact() {
      return this.contactData?.contact;
    },
    member() {
      return this.contactData?.member;
    },
    contactDetails() {
      return [
        {
          name: "Company",
          value: this.member?.company_name,
        },
        {
          name: "Title",
          value: this.contact?.title,
        },
        {
          name: "Work Phone",
          value: this.contact?.work_phone,
        },
        {
          name: "Fax",
          value: this.contact?.fax,
        },
        {
          name: "Email",
          value: this.contact?.email,
        },
        {
          name: "LinkedIn URL",
          value: this.contact?.linkedin_url,
        },
        {
          name: "Address",
          value: [
            this.contact?.address1,
            this.contact?.address2,
            this.contact?.city,
            this.contact?.state,
            this.contact?.zip,
          ]
            .filter(Boolean)
            .join(", "),
        },
        {
          name: "Country",
          value: this.contact?.country,
        },
      ];
    },
  },
};
</script>
